'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _errors = require('api/errors.constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = require('debug')('ApiClient');
log.useColors = true;

var log2 = require('debug')('ApiClient:data');
log2.useColors = true;

var methods = ['get', 'post', 'put', 'patch', 'del'];

// todo: переделать данный функция
function formatUrl(path) {
    var pathToServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var adjustedPath = path[0] !== '/' ? '/' + path : path;
    if (pathToServer) {
        return pathToServer + adjustedPath;
    } else if (__SERVER__) {
        // Prepend host and port of the API server to the path.
        return _config2.default.apiHost + adjustedPath;
    }
    // Prepend `/api` to relative URL, to proxy to API server.
    return '/api' + adjustedPath;
}

var ApiClient = function () {
    function ApiClient(req) {
        var _this = this;

        (0, _classCallCheck3.default)(this, ApiClient);

        this.req = req;
        methods.forEach(function (method) {
            return _this[method] = function (path) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                    params = _ref.params,
                    data = _ref.data;

                var pathToServer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                return new _promise2.default(function (resolve, reject) {

                    var uuid = require('uuid').v4();
                    //region debug
                    log('[' + uuid + ' url] ==> ', formatUrl(path, pathToServer));
                    log('[' + uuid + ' method] ==> ', method);
                    if (data) {
                        log('[' + uuid + ' data] ==> ', data);
                    }
                    if (params) {
                        log('[' + uuid + ' params] ==> ', params);
                    }
                    log('------------------------');
                    //endregion

                    var request = _superagent2.default[method](formatUrl(path, pathToServer));

                    if (params) {
                        request.query(params);
                    }

                    if (__SERVER__ && req.get('cookie')) {
                        request.set('cookie', req.get('cookie'));
                    }

                    var start = new Date();

                    if (data) {
                        request.send(data);
                    }

                    request.end(function (err) {
                        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                            body = _ref2.body;

                        // костыль (ответ - большая портанка)
                        if (!/(get-lang-data)/g.test(path)) {
                            var end = new Date();
                            log2('[' + uuid + ' request end time] ==> ' + (end - start) + 'ms');
                            log2('[' + uuid + ' request end method] ==> ', method);
                            log2('[' + uuid + ' request end url] ==> ', formatUrl(path, pathToServer));
                            log2('[' + uuid + ' request end err] ==> ', err);
                            log2('[' + uuid + ' request end body] ==> ', body);
                            log2('------------------------');
                        }

                        if (err) {
                            _this.processError(err);
                            return reject(body || err);
                        }

                        return resolve(body);
                    });
                });
            };
        });
    }

    (0, _createClass3.default)(ApiClient, [{
        key: 'processError',
        value: function processError(err) {
            // Если во время запроса произошло резкое обрывание.
            // Например, в фаерфоксе страница делает запрос, мы
            // нажимаем F5 и не даем ему завершится - фаерфокс в
            // таком случае просто обрубить его и выпадет ошибка
            if (err.code == null && err.status == null && err.response == null && err instanceof Error) {
                err.code = _errors.ERROR_CODE_CONNECTION_CLOSE_UBNORMAL;
                err.status = _errors.ERROR_STATUS_FOR_INTERNAL_CASE;
            }
        }
    }, {
        key: 'getRaw',
        value: function getRaw(path) {
            var pathToServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return new _promise2.default(function (resolve, reject) {

                //region debug
                log('[url] ==> ', formatUrl(path, pathToServer));
                log('------------------------');
                //endregion

                var request = _superagent2.default.get(formatUrl(path, pathToServer));

                request.end(function (err) {
                    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                        text = _ref3.text;

                    // log2('[err] ==> ', err);
                    // log2('[text] ==> ', text);
                    if (err) {
                        return reject(err);
                    }

                    return resolve(text);
                });
            });
        }
    }, {
        key: 'empty',


        /*
         * There's a V8 bug where, when using Babel, exporting classes with only
         * constructors sometimes fails. Until it's patched, this is a solution to
         * "ApiClient is not defined" from issue #14.
         * https://github.com/erikras/react-redux-universal-hot-example/issues/14
         *
         * Relevant Babel bug (but they claim it's V8): https://phabricator.babeljs.io/T2455
         *
         * Remove it at your own risk.
         */
        value: function empty() {}
    }]);
    return ApiClient;
}();

exports.default = ApiClient;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/api/ApiClient.js
// module id = 741
// module chunks = 0